import StyledHeader from '../Header';

const Header = StyledHeader;

export default Header;
